import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import baseFormMuiTheme from './baseFormMuiTheme';

const theme = createTheme(baseFormMuiTheme);

const responseInputMuiTheme = createTheme(
  deepmerge(theme, {
    components: {
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            alignItems: 'flex-end',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 4,
            marginLeft: 0,
            marginRight: 0,
            marginBottom: 0,
            '& .MuiCheckbox-root': {
              padding: 9,
            },
            '& .Mui-checked.MuiCheckbox-colorPrimary.Mui-disabled, .Mui-checked.MuiRadio-colorPrimary.Mui-disabled':
              {
                color: `${theme.palette.secondary.main} !important`,
              },
            '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
              color: `${theme.palette.text.primary} !important`,
              fontSize: '14px',
              marginBottom: 11,
            },
          },
        },
      },
      MuiFormGroup: {
        styleOverrides: {
          root: {
            gap: 10,
          },
        },
      },
    },
  }),
);

export default responseInputMuiTheme;
